import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const G_ThirdRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            G_del_dis,
            G_DarzanChange,
            G_darzan,
            G_CartonChange,
            G_nrxchange,
            G_nrx,
            G_search,
            G_karton,
            G_naweSht,
            G_setSaletSearchEmty,
            G_getProductDataBySearchRent,
            G_zhmara,
            G_toSavebyEnter,
            G_qazanj,
            G_joripara,
            G_getkoygahty,
            G_rezha,
            toanotherInput,
            G_createNewPage,
            G_open,
            G_wasl,
            G_saveDetail,
            G_toThirdRow,
            G_rasidKarton
          } = value;
          return (
            <>
              {/* starting 1 row */}
              <form>
                {G_search == true ? (
                  <div className="row text-warning font-weight-bold ">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-4">
                      <h5
                        className="border b--black"
                        style={{ backgroundColor: "#32CD32", color: "#000" }}
                        name="qazanj"
                      >
                        Q$ {G_qazanj}
                      </h5>
                    </div>
                    <div className="col-sm-4">
                      <h5
                        className="border b--black"
                        style={{ backgroundColor: "#32CD32", color: "#000" }}
                        name="rasid"
                      >
                        R {G_rasidKarton}
                      </h5>
                    </div>
                  </div>
                ) : null}
                <div className="row">
                  <div className="col-sm-3 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">دەرزەن</label>
                      <input
                        type="text"
                        disabled={G_del_dis == true ? true : null}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? G_toThirdRow(event) : null
                        }
                        onChange={(e) => G_DarzanChange(e)}
                        value={G_darzan == 0 ? "" : G_darzan}
                        name="G_darzan"
                        className="form-control text-right font-weight-bold pr-4"
                      />
                    </div>
                  </div>
                  <div className="col-sm-2 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کارتۆن</label>
                      <input
                        type="text"
                        disabled={G_del_dis == true ? true : null}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? toanotherInput(event) : null
                        }
                        onChange={G_CartonChange}
                        value={G_karton == 0 ? "" : G_karton}
                        name="G_karton"
                        className="form-control text-right font-weight-bold pr-4"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">ناوی شتەکان</label>
                      <input
                        type="text"
                        disabled={G_del_dis == true ? true : null}
                        value={G_naweSht}
                        name="G_naweSht"
                        onKeyPress={(event) =>
                          event.key == "Enter" ? toanotherInput(event) : null
                        }
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کۆد</label>
                      <input
                        type="text"
                        onClick={G_setSaletSearchEmty}
                        disabled={G_del_dis == true ? true : null}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? G_getProductDataBySearchRent(event)
                            : null
                        }
                        value={G_zhmara}
                        name="G_zhmara"
                        onChange={AddProChange}
                        className="form-control text-right font-weight-bold tc pr-4"
                      />
                    </div>
                  </div>
                </div>
                {/* end of 1 */}
                {/* starting 2 row */}
                <div className="row card-header p-1 border-bottom border-warning">
                  <div className="col-3 text-right px-2 mt4">
                    <button
                      onClick={G_createNewPage}
                      disabled={G_open == true ? true : null}
                      className={`btn ${
                        G_open == true ? "btn-danger" : "btn-primary"
                      } mr4 mt2`}
                    >
                      <i className="far fa-file fa-lg"></i>
                    </button>
                    <button
                      onClick={(e) => G_saveDetail(e, G_wasl)}
                      className="btn btn-success mt2"
                    >
                      <i className="far fa-save"></i>
                    </button>
                  </div>
                  <div className="col-sm-4 text-right ">
                    <div className="form-group ">
                      {G_joripara == "دۆلار" ? (
                        <>
                          <label className="fk">$ کۆی گشتی </label>
                          <input
                            type="number"
                            disabled={G_del_dis == true ? true : null}
                            value={
                              G_karton > 0 || G_darzan > 0
                                ? G_getkoygahty(G_darzan, G_karton)
                                : 0
                            }
                            onChange={AddProChange}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_saveDetail(event, G_wasl)
                                : null
                            }
                            name="R_koygshty$"
                            onChange={AddProChange}
                            className="form-control text-right font-weight-bold tc"
                          />
                        </>
                      ) : (
                        <>
                          <label className="fk">ID کۆی گشتی </label>
                          <input
                            type="number"
                            disabled={G_del_dis == true ? true : null}
                            value={
                              G_karton > 0 || G_darzan > 0
                                ? G_getkoygahty(G_darzan, G_karton)
                                : 0
                            }
                            onChange={AddProChange}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_saveDetail(event, G_wasl)
                                : null
                            }
                            name="R_koygshtyID"
                            onChange={AddProChange}
                            className="form-control text-right font-weight-bold tc"
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-2 text-right ">
                    <div className="form-group">
                      <label className="font-weight-bold f4">ڕێژە</label>
                      <input
                        type="number"
                        disabled={G_del_dis == true ? true : null}
                        value={G_rezha}
                        name="G_rezha"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3 text-right ">
                    <div className="form-group">
                      <label className="font-weight-bold f4">نرخ</label>
                      <input
                        type="text"
                        disabled={G_del_dis == true ? true : null}
                        value={G_nrx}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? G_toSavebyEnter(event) : null
                        }
                        name="G_nrx"
                        onChange={G_nrxchange}
                        className="form-control text-right font-weight-bold pr-4"
                      />
                    </div>
                  </div>
                </div>
              </form>
              {/* end of 2 */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default G_ThirdRow;
